import api from '@/apis/di/stockAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {getCurrentInstance} from 'vue';

// Combo grid CTMT
export const useStockComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const {proxy} = getCurrentInstance();
  const {extendFilter} = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onStockComboboxLoadData = (payload, row, column, customData) => {
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [{Field: 'inactive', Value: false, Ors: ors}];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'stock_code';
    // tk kho ngầm định
    if (payload.columns && !payload.columns.includes('default_account_number')) {
      payload.columns += ',default_account_number';
    }
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };

  // config columns combo
  const stockComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã kho',
        dataField: 'stock_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên kho',
        dataField: 'stock_name',
        width: 480,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ],
    displayField: 'stock_code',
    valueField: 'stock_id',
    queryMode: 'remote',
    quickSearch: 'StockQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive,
    },
    dropdownWidth: 600,
    comboboxLoadData: onStockComboboxLoadData,
  };

  return {
    stockComboConfig,
    onStockComboboxLoadData, // trả về thêm để dùng chung chả cả combo ko thuộc grid
  };
};
